"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserAuthRedirectRouter = exports.NextAuthRedirectRouter = exports.getAuthRedirectRouter = void 0;
var getAuthRedirectRouter_1 = require("./getAuthRedirectRouter");
Object.defineProperty(exports, "getAuthRedirectRouter", { enumerable: true, get: function () { return getAuthRedirectRouter_1.getAuthRedirectRouter; } });
var NextAuthRedirectRouter_1 = require("./router/NextAuthRedirectRouter");
Object.defineProperty(exports, "NextAuthRedirectRouter", { enumerable: true, get: function () { return NextAuthRedirectRouter_1.NextAuthRedirectRouter; } });
var BrowserAuthRedirectRouter_1 = require("./router/BrowserAuthRedirectRouter");
Object.defineProperty(exports, "browserAuthRedirectRouter", { enumerable: true, get: function () { return BrowserAuthRedirectRouter_1.browserAuthRedirectRouter; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsaUVBQWdFO0FBQXZELDhIQUFBLHFCQUFxQixPQUFBO0FBQzlCLDBFQUF5RTtBQUFoRSxnSUFBQSxzQkFBc0IsT0FBQTtBQUMvQixnRkFBK0U7QUFBdEUsc0lBQUEseUJBQXlCLE9BQUEifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/auth-redirect-router/index.js
// module id = 4420
// module chunks = 25